import { isPlatformBrowser } from '@angular/common';
import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

import { AnalyticsService } from '@digital-platform/rs-analytics/services';
import { WindowService } from './window.service';

@Injectable()
export class YoutubeService {
  public youtubePlay$: Observable<object>;
  public youtubePause$: Observable<object>;
  public youtubeFinish$: Observable<object>;

  private onYouTubeIframeAPIReady$ = new BehaviorSubject<boolean>(false);
  private _youtubePlay: Subject<object>;
  private _youtubePause: Subject<object>;
  private _youtubeFinish: Subject<object>;

  private platformId = inject(PLATFORM_ID);

  private analyticsService = inject(AnalyticsService);
  private windowService = inject(WindowService);

  constructor() {
    this._youtubePlay = new Subject();
    this._youtubePause = new Subject();
    this._youtubeFinish = new Subject();

    this.youtubePlay$ = this._youtubePlay.asObservable();
    this.youtubePause$ = this._youtubePause.asObservable();
    this.youtubeFinish$ = this._youtubeFinish.asObservable();

    const onReady = () => {
      this.onYouTubeIframeAPIReady$.next(true);
    };

    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    if (typeof this.windowService.nativeWindow.YT === 'undefined') {
      this.windowService.nativeWindow.onYouTubeIframeAPIReady = onReady;
    } else if (this.windowService.nativeWindow.YT.loaded) {
      onReady();
    } else {
      this.windowService.nativeWindow.YT.ready(onReady);
    }
  }

  public get onYouTubeIframeAPIReady(): Observable<boolean> {
    return this.onYouTubeIframeAPIReady$.asObservable();
  }

  public youtubePlay(player: Record<string, unknown>) {
    this.analyticsService.trackVideoStart();
    this._youtubePlay.next(player);
  }

  public youtubePause(player: Record<string, unknown>) {
    this.analyticsService.trackVideoPause();
    this._youtubePause.next(player);
  }

  public youtubeFinish(player: Record<string, unknown>) {
    this._youtubeFinish.next(player);
  }
}
